import { createTheme, Theme } from '@mui/material/styles';

declare module '@mui/styles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

declare module '@mui/material/styles' {
  interface Palette {
    contentpackages: Palette['primary'];
    calendar: Palette['primary'];
  }

  interface PaletteOptions {
    contentpackages?: PaletteOptions['primary'];
    calendar?: PaletteOptions['primary'];
  }
}

const primary = '#0064C9';

const white = '#ffffff';
const vulcan = '#404041';
const stormDust = '#626366';
const gunSmoke = '#808284';
const darkFeatherGray = '#E5E5E5';
const featherGray = '#F8F8F8';

const error = '#EB4D5C';

const theme = createTheme({
  palette: {
    common: {
      white,
      black: vulcan,
    },
    background: {
      default: white,
      paper: white,
    },
    primary: {
      main: primary,
      dark: '#003B97',
      light: '#5B91FD',
      // light: primaryLight,
      // contrastText: 'rgba(256, 256, 256, 0.96)',
    },
    secondary: {
      main: error,
    },
    contentpackages: {
      main: '#52489C',
      light: '#B0ABD8',
      dark: '#52489C',
      contrastText: '#fff',
    },
    calendar: {
      main: '#B00EBC',
      light: '#E554EF',
      dark: '#7C008B',
      contrastText: '#fff',
    },
    warning: {
      main: '#FFCC00',
      light: '#FFF8D9',
    },
    success: {
      main: '#4cd964',
      light: '#85ff94',
      dark: '#00a635',
      contrastText: 'rgba(256, 256, 256, 0.96)',
    },
    grey: {
      100: featherGray,
      200: darkFeatherGray,
      500: gunSmoke,
      900: stormDust,
    },
    error: {
      main: error,
    },
    text: {
      primary: vulcan,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          WebkitFontSmoothing: 'auto',
        },
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em',
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          color: 'rgba(256, 256, 256, 0.96)',
          backgroundColor: vulcan,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
        },
        colorDefault: {
          backgroundColor: featherGray,
          color: vulcan,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorDefault: {
          backgroundColor: white,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          margin: 16,
        },
        paperFullWidth: {
          width: 'calc(100% - 32px)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        icon: {
          marginLeft: '8px',
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: vulcan,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
  },
  typography: {
    fontSize: 14,
    htmlFontSize: 14,
    fontFamily: "'Circular-Pro', sans-serif",
    h1: {
      fontSize: '1.5rem',
      fontWeight: 700,
      lineHeight: 1.334,
      letterSpacing: '0rem',
    },
    h2: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.6,
      letterSpacing: '0.0075em',
    },
    h3: {
      fontSize: '1.14rem',
      fontWeight: 500,
      lineHeight: 1.6,
      letterSpacing: '0.0075em',
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 200,
      lineHeight: 1.5,
      letterSpacing: '0.00938em',
    },
    body2: {
      fontSize: '0.875rem',
      fontWeight: 200,
      lineHeight: 1.5,
      letterSpacing: '0.00938em',
    },
  },
});

export default theme;
